import DOMPurify from 'dompurify'

export const getSanitizeData = a_inputString => {
    const config = {
        ALLOWED_TAGS: [], 
        RETURN_DOM: false, 
        USE_PROFILES: {html: false},
        ALLOW_DATA_ATTR: false
    };

    return DOMPurify.sanitize(a_inputString, config);
}

export const getFormatedDate =date => {
    const dateArr = date.split('-');
    const shortMonthArr = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

    return  dateArr[2] +"-"+ shortMonthArr[Number(dateArr[1])-1] +"-"+ dateArr[0];
}

export const convertImoticonTextToHexCodeText = inputText => {
    let processedText ="";
    const inputTextLength = inputText.length;
    let i = 0;
    while(i < inputTextLength){
		if(inputText.codePointAt(i)) {
			const rex = /0[xX]1f[3-9][0-9A-F][0-9A-F]/gi;
			const codePoint = "0x"+ inputText.codePointAt(i).toString(16);                
			if(codePoint.match(rex)) {
				processedText += codePoint;
				i++;
			} else {
                processedText += inputText[i];
			}
		} else {
			processedText += inputText[i];
		}
        i++;
	}

    return processedText;
}